import { TextInput } from "flowbite-react";
import { useState } from "react";
import { HiOutlineEye, HiOutlineEyeOff } from "react-icons/hi";
import { FieldLabel } from "../atoms/FieldLabel";

type InputPasswordProps = {
  label?: string;
  className?: string;
  isInvalid?: boolean;
  rhfControls: any;
  errorMessage?: string;
  placeholder?: string;
  rest?: Record<string, any>;
};

const BsInputPassword = (props: InputPasswordProps) => {
  const [show, setShow] = useState(false);

  return (
    <div className={props.className + " flowBitePasswordInput"} dir="auto">
      {props.label && (
        <FieldLabel
          htmlFor={props.label}
          className="text-sm font-medium text-gray-700 block mb-3 text-start"
        >
          {props.label}
        </FieldLabel>
      )}

      <div
        className={`w-full ps-[17px] pe-[13px] py-2 rounded-md
         justify-between items-center inline-flex ${
           props.isInvalid
             ? "border-red-500 border-[2px]"
             : "border-gray-300 border-[1px]"
         }`}
      >
        <TextInput
          className="w-full me-2 text-gray-900 text-sm font-normal font-figtree leading-tight"
          id={props.label}
          placeholder={props.placeholder}
          type={show ? "text" : "password"}
          color={props.isInvalid ? "failure" : undefined}
          autoComplete="current-password"
          {...props.rest}
          {...props.rhfControls}
        />

        <button
          className="w-5 h-5 relative"
          type="button"
          onClick={() => setShow(!show)}
          disabled={props.rest?.disabled}
        >
          {!show ? (
            <HiOutlineEye className="text-gray-400" size={20} />
          ) : (
            <HiOutlineEyeOff className="text-gray-400" size={20} />
          )}
        </button>
      </div>

      {props.errorMessage && (
        <div className="block mt-2 text-red-600 text-sm">
          {props.errorMessage}
        </div>
      )}
    </div>
  );
};

export default BsInputPassword;
